var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDone24Pxgreen = function SvgDone24Pxgreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1.5rem",
    height: 18,
    viewBox: "0 0 24 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "done_24pxgreen_svg__a",
    d: "m11.733 21.2-5.6-5.6-1.866 1.867 7.466 7.466 16-16-1.866-1.866z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "done_24pxgreen_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#done_24pxgreen_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#00693C",
    mask: "url(#done_24pxgreen_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgDone24Pxgreen;